import { hyphenateSync as hyphenate } from "hyphen/nl"
import { library } from "../../Generic/libraries"

export const hyphen: (text: string) => string = text => {
  const { autoHyphenate, manualHyphenate } = library().features

  // If manual hyphenation is enabled and relevant for this text
  if (manualHyphenate && text.includes('|')) {
    let result = text;

    // If pipe is found around space, replace all others with non-breaking-space.
    // This allows editors to force a break after a particular word, but only when the text does not fit on one line.
    if (text.includes(' |') || text.includes('| ')) {
      result = text.replace(/ /g, '\u00A0').replace(/(\u00A0\|)|(\|\u00A0)/g, ' ');
    }

    return result
      .replace(/(-\|)|(\|-)/g, '-') // If the pipe (`|`) is placed near an actual hyphen, we prefer to use that hyphen over the proposed soft-hyphen.
      .replace(/\|/g, '\u00AD'); // Otherwise replace the pipe with a soft-hyphen.
  }

  return autoHyphenate ? hyphenate(text) : text;
};
